import { c as _c } from "react/compiler-runtime";
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import useSWR from 'swr';
import { PUBLIC_API_SETTINGS } from '../api/public-api-settings-api';
import { KeyTypeEnum, McpSettingsViewInterface, PublicApiSettingsViewInterface } from '../types/public-api-settings-interface';
export function usePublicKeys() {
  const $ = _c(11);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher: getFetcherApiKeys
  } = useFetch(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    fetcher: getFetcherMcpKeys
  } = useFetch(t1);
  let t2;
  if ($[2] !== user) {
    t2 = () => user && `${PUBLIC_API_SETTINGS}?type=${KeyTypeEnum.Api}`;
    $[2] = user;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    data: apiKeys,
    mutate: mutateApiKeys
  } = useSWR(t2, getFetcherApiKeys);
  let t3;
  if ($[4] !== user) {
    t3 = () => user && `${PUBLIC_API_SETTINGS}?type=${KeyTypeEnum.Mcp}`;
    $[4] = user;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    data: mcpKeys,
    mutate: mutateMCPKeys
  } = useSWR(t3, getFetcherMcpKeys);
  let t4;
  if ($[6] !== apiKeys || $[7] !== mcpKeys || $[8] !== mutateApiKeys || $[9] !== mutateMCPKeys) {
    t4 = {
      apiKeys,
      mcpKeys,
      mutateMCPKeys,
      mutateApiKeys
    };
    $[6] = apiKeys;
    $[7] = mcpKeys;
    $[8] = mutateApiKeys;
    $[9] = mutateMCPKeys;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}